/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { ChangeEvent, Fragment, useEffect, useState } from 'react'
import { Modal } from 'antd-mobile'
// css
import { ModalBg } from '@styles/base.style'
import { Button, ButtonWrap, PopupBtnStyle, SwitchBtnWrap } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'

const Setting: React.FC = props => {
  const { globalStore, authStore } = useRootStore()
  const { visibleGameSetting } = globalStore
  const { userInfo } = authStore
  const [simpleModeChecked, setSimpleModeChecked] = useState(userInfo.isSpecificClubMember)
  const [showRecommendClubChecked, setShowRecommendClubChecked] = useState(userInfo.isSpecificClubMember)

  useEffect(() => {
    setSimpleModeChecked(userInfo.isSpecificClubMember)
    setShowRecommendClubChecked(userInfo.isSpecificClubMember)
  }, [userInfo])

  const onCloseModal = async () => {
    globalStore.setVisibleGameSetting(false)
  }

  const onChangeSimpleModeHandler = (event: ChangeEvent) => {
    setSimpleModeChecked(!simpleModeChecked)
  }

  const onChangeShowRecommendClubHandler = (event: ChangeEvent) => {
    setShowRecommendClubChecked(!showRecommendClubChecked)
  }

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleGameSetting}
        maskClosable={false}
        onClose={onCloseModal}
        className="custom-dialog"
        title='설정'
      >
        <SwitchBtnWrap>
          <span className="switch-btn-wrap">
            <p className="switch-btn-wrap--txt">간소화 모드</p>
            <input
              type="checkbox"
              id="simpleModeSetting"
              name="simpleModeSetting"
              value="simpleMode"
              className="switch-btn-wrap--btn"
              onChange={onChangeSimpleModeHandler}
              checked={simpleModeChecked}
              disabled />
            <span className="on-off-wrap">
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </span>
          </span>
          <span className="switch-btn-wrap">
            <p className="switch-btn-wrap--txt">추천 클럽만 보기</p>
            <input
              type="checkbox"
              id="viewClubSetting"
              name="viewClubSetting"
              value="viewClub"
              className="switch-btn-wrap--btn"
              onChange={onChangeShowRecommendClubHandler}
              checked={showRecommendClubChecked}
              disabled />
            <span className="on-off-wrap">
              <span className="on">ON</span>
              <span className="off">OFF</span>
            </span>
          </span>
        </SwitchBtnWrap>
        <ButtonWrap className="custom-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} css={PopupBtnStyle} className="one-button">
            확인
          </Button>
        </ButtonWrap>

        <ModalBg onClick={onCloseModal} />
      </Modal>
    </Fragment>
  )
}

export default observer(Setting)
